module.exports = __webpack_public_path__ + "static/media/warning-slim.1c98a24c.svg";